import { render, staticRenderFns } from "./WarehouseInput.vue?vue&type=template&id=08a6ab9a&scoped=true&"
import script from "./WarehouseInput.vue?vue&type=script&lang=js&"
export * from "./WarehouseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6ab9a",
  null
  
)

export default component.exports